
<template>
  <v-container fluid>
    <group-card
      v-for="(group, idx) in done_groups"
      :key="group.id"
      :group="group"
      class="mb-3"
    ></group-card>
  </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: "GroupList",
  components: {
    GroupCard: () => import("./GroupCard.vue"),
  },
  computed: {
    ...mapState({
      done_groups: state => state.FlowExecution.done_groups
    })
  },
}
</script>

<style scoped>

</style>